import { render, staticRenderFns } from "./LoveNow.vue?vue&type=template&id=cae16b7c&scoped=true"
import script from "./LoveNow.vue?vue&type=script&lang=js"
export * from "./LoveNow.vue?vue&type=script&lang=js"
import style0 from "./LoveNow.vue?vue&type=style&index=0&id=cae16b7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae16b7c",
  null
  
)

export default component.exports